import { render, staticRenderFns } from "./Feature.vue?vue&type=template&id=6a29f728&scoped=true&"
import script from "./Feature.vue?vue&type=script&lang=ts&"
export * from "./Feature.vue?vue&type=script&lang=ts&"
import style0 from "./Feature.vue?vue&type=style&index=0&id=6a29f728&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a29f728",
  null
  
)

export default component.exports